import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sun, Moon } from "lucide-react";
import { cx } from "@/components/site/primitives";

export const ThemeToggle = ({ dark, toggle, className = "" }) => (
  <button onClick={toggle} data-testid="theme-toggle" aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
    className={cx("relative grid h-11 w-11 place-items-center rounded-full border border-line bg-card text-ink transition-colors hover:border-coral/50", className)}>
    <AnimatePresence mode="wait" initial={false}>
      {dark ? (
        <motion.span key="moon" initial={{ opacity: 0, rotate: -40, scale: 0.6 }} animate={{ opacity: 1, rotate: 0, scale: 1 }} exit={{ opacity: 0, rotate: 40, scale: 0.6 }} transition={{ duration: 0.25 }}>
          <Moon className="h-[18px] w-[18px] text-yellow" />
        </motion.span>
      ) : (
        <motion.span key="sun" initial={{ opacity: 0, rotate: 40, scale: 0.6 }} animate={{ opacity: 1, rotate: 0, scale: 1 }} exit={{ opacity: 0, rotate: -40, scale: 0.6 }} transition={{ duration: 0.25 }}>
          <Sun className="h-[18px] w-[18px] text-coral" />
        </motion.span>
      )}
    </AnimatePresence>
  </button>
);
